<template>
  <div class="editCost">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="项目">{{cueRowData.serviceName}}</el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin:20px 0">
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="手工费" prop="manualFee">
            <el-input v-model="form.manualFee" placeholder="请输入手工费" style="width:180px"></el-input>&nbsp;&nbsp;元
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="生效时间" prop="time">
            <el-date-picker
              v-model="form.time"
              type="datetime"
              placeholder="选择生效时间"
              style="width:180px"
              value-format="timestamp"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row class="btnOptions">
          <el-button class="darkBtn" @click="resetData">取消</el-button>
          <el-button class="redBtn" @click="onSubmit" :disabled="btnCostFlag">确定</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { operateManualFee } from "@/api";

export default {
  props: ['cueRowData','openFlag'],
  data() {
    // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (Number(value)) {
        if (
          !Number.isInteger(Number(value)) &&
          value.toString().split(".")[1].length > 2
        ) {
          callback(new Error("不能超过两位小数"));
        } else if (Number(value) > 9999999.99) {
          callback(new Error("金额最大9999999.99"));
        } else if (Number(value) < 0) {
          callback(new Error("金额不能为负"));
        } else {
          callback();
        }
      } else if (!value || value == "") {
        callback();
      } else {
        callback(new Error("金额只能是数字，且保留两位小数"));
      }
    };
    return {
      form: {
        manualFee: "",
        time: ""
      },
      rules: {
        manualFee: [
          {
            required: true,
            message: "请输入手工费",
            trigger: "blur"
          },
          { type: "number", validator: isvalidateMoney }
        ],
        time: [
          {
            required: true,
            message: "请选择生效时间",
            trigger: "change"
          }
        ]
      },
      btnCostFlag:this.openFlag
    };
  },
  created () {
    this.form = Object.assign({},this.cueRowData);
  },
  watch: {
    'cueRowData'(){
      this.$refs.form.clearValidate();
      this.form = Object.assign({},this.cueRowData);
    },
    'openFlag'(){
      this.btnCostFlag = this.openFlag;
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.btnCostFlag = true;
          let post = {
            serviceId:this.cueRowData.serviceId,
            manualFee:this.form.manualFee
          };
          operateManualFee(post).then(res => {
            if (res.code == 1) {
              // 关闭当前进入列表页
              this.$emit("closeDialog", false);
            }else{
              this.btnCostFlag = false;
            }
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        } else {
          this.btnCostFlag = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetData() {
      this.$confirm(
        "确定要取消本次编辑的信息吗？取消后本次编辑的内容不保存",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "继续编辑",
          cancelButtonText: "确定取消",
          type: "warning"
        }
      )
        .then(() => {})
        .catch(action => {
          if (action === "cancel") {
            this.$message({
              type: "info",
              message: "已取消"
            });
            this.$refs.form.resetFields();
            this.$emit("closeDialog", false);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.editCost {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .seize {
    height: 20px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="less">
.editCost {
  .lineH {
    .el-form-item__content {
      line-height: 25px;
      padding-top: 8px;
    }
  }
  .el-form-item__content {
    text-align: left;
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
  }
  .btnOptions {
    margin-top: 50px;
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/editCost.vue